import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import { Fragment, ReactNode } from 'react'

import cn from '@/utilities/cn'

type PanelProps = {
  size?: 'sm' | 'lg' | 'xl'
  position?: 'left' | 'right'

  show: boolean
  onClose: () => void
  children: ReactNode | (() => ReactNode)

  beforeEnter?: () => void
  afterEnter?: () => void
  beforeLeave?: () => void
  afterLeave?: () => void
}

function Panel({ size = 'sm', position = 'right', show, onClose, children, ...props }: PanelProps) {
  return (
    <Transition show={show} as={Fragment} {...props}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className={cn(
                'pointer-events-none fixed inset-y-0 flex max-w-full',
                { left: 'left-0 pr-10 sm:pr-16', right: 'right-0 pl-10 sm:pl-16' }[position]
              )}
            >
              <TransitionChild
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom={{ left: '-translate-x-full', right: 'translate-x-full' }[position]}
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo={{ left: '-translate-x-full', right: 'translate-x-full' }[position]}
              >
                <DialogPanel
                  className={cn(
                    'pointer-events-auto w-screen',
                    { sm: 'max-w-md', lg: 'max-w-2xl', xl: 'max-w-4xl' }[size]
                  )}
                >
                  <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                    {typeof children === 'function' ? children() : children}
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

Panel.Title = DialogTitle

export default Panel
